var map = {
	"./all-cross.mod.ts": 13488,
	"./bid-bot.mod.ts": 65187,
	"./car-body.mod.ts": 31237,
	"./cat-ia.mod.ts": 17439,
	"./class-merch-clusters.mod.ts": 38730,
	"./class-merch.mod.ts": 74741,
	"./index.mod.ts": 55734,
	"./invoice-xml.mod.ts": 57097,
	"./login.mod.ts": 91297,
	"./order-bot.mod.ts": 9604,
	"./pfa-rules.mod.ts": 70338,
	"./price-compare.mod.ts": 25580,
	"./products-sizes.mod.ts": 10973,
	"./q-bot.mod.ts": 61334,
	"./q-ricambi.mod.ts": 34358,
	"./stock-bot.mod.ts": 43277,
	"./stock-offers.mod.ts": 1085,
	"./supplier-promo.mod.ts": 96859,
	"./supplier.mod.ts": 85080,
	"./teccom.mod.ts": 52299,
	"./traders.mod.ts": 69716,
	"./x-bot.mod.ts": 33370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85468;